export default __webpack_public_path__ + "555ee19e0309c25905c89d8294684193.svg";